export class CognitoGroups {
  static ADMIN = 'Admin';
  static ADVANCED = 'Advanced';
  static SUBSCRIBER = 'Subscriber';
  static ALL = 'All';

  static getGroups() {
    return [this.ADMIN, this.ADVANCED, this.SUBSCRIBER];
  }
}